import { ValidationError, NonJSONResponseError } from '../errors';
import { validateAckBody, validateAck200, validateAck403, validateAck404, validateDisconnectCall200, validateDisconnectCall403, validateDisconnectCall502, validateDisconnectCall503, validateDtmfBody, validateDtmf200, validateDtmf403, validateFeccBody, validateFecc200, validateFecc403, validateNewCandidateBody, validateNewCandidate200, validateNewCandidate403, validateNewCandidate502, validateUpdateBody, validateUpdate200, validateUpdate403, validateUpdate500, validateUpdate502, validateUpdate503, validateUpdate520, validateStatisticsBody, validateStatistics200, validateStatistics403, validateRequestAudioStreamBody, validateRequestAudioStream200, validateRequestAudioStream403, validateRequestVideoStreamBody, validateRequestVideoStream200, validateRequestVideoStream403, validateReleaseAudioStreamBody, validateReleaseAudioStream200, validateReleaseAudioStream403, validateReleaseVideoStreamBody, validateReleaseVideoStream200, validateReleaseVideoStream403, } from './validation';
export async function ack({ fetcher, init, params, body, host, }) {
    if (!validateAckBody(body)) {
        throw new ValidationError(validateAckBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/ack`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateAck200(data)) {
                throw new ValidationError(validateAck200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateAck403(data)) {
                throw new ValidationError(validateAck403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 404) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateAck404(data)) {
                throw new ValidationError(validateAck404.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function disconnectCall({ fetcher, init, params, host, }) {
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/disconnect`, {
        ...init,
        method: 'post',
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateDisconnectCall200(data)) {
                throw new ValidationError(validateDisconnectCall200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateDisconnectCall403(data)) {
                throw new ValidationError(validateDisconnectCall403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 502) {
        const data = await res.text();
        if (!validateDisconnectCall502(data)) {
            throw new ValidationError(validateDisconnectCall502.errors);
        }
        return { status: res.status, data };
    }
    if (res.status === 503) {
        const data = await res.text();
        if (!validateDisconnectCall503(data)) {
            throw new ValidationError(validateDisconnectCall503.errors);
        }
        return { status: res.status, data };
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function dtmf({ fetcher, init, params, body, host, }) {
    if (!validateDtmfBody(body)) {
        throw new ValidationError(validateDtmfBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/dtmf`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateDtmf200(data)) {
                throw new ValidationError(validateDtmf200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateDtmf403(data)) {
                throw new ValidationError(validateDtmf403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function fecc({ fetcher, init, params, body, host, }) {
    if (!validateFeccBody(body)) {
        throw new ValidationError(validateFeccBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/fecc`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateFecc200(data)) {
                throw new ValidationError(validateFecc200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateFecc403(data)) {
                throw new ValidationError(validateFecc403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function newCandidate({ fetcher, init, params, body, host, }) {
    if (!validateNewCandidateBody(body)) {
        throw new ValidationError(validateNewCandidateBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/new_candidate`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateNewCandidate200(data)) {
                throw new ValidationError(validateNewCandidate200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateNewCandidate403(data)) {
                throw new ValidationError(validateNewCandidate403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 502) {
        const data = await res.text();
        if (!validateNewCandidate502(data)) {
            throw new ValidationError(validateNewCandidate502.errors);
        }
        return { status: res.status, data };
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function update({ fetcher, init, params, body, host, }) {
    if (!validateUpdateBody(body)) {
        throw new ValidationError(validateUpdateBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/update`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateUpdate200(data)) {
                throw new ValidationError(validateUpdate200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateUpdate403(data)) {
                throw new ValidationError(validateUpdate403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 500) {
        const data = await res.text();
        if (!validateUpdate500(data)) {
            throw new ValidationError(validateUpdate500.errors);
        }
        return { status: res.status, data };
    }
    if (res.status === 502) {
        const data = await res.text();
        if (!validateUpdate502(data)) {
            throw new ValidationError(validateUpdate502.errors);
        }
        return { status: res.status, data };
    }
    if (res.status === 503) {
        const data = await res.text();
        if (!validateUpdate503(data)) {
            throw new ValidationError(validateUpdate503.errors);
        }
        return { status: res.status, data };
    }
    if (res.status === 520) {
        const data = await res.text();
        if (!validateUpdate520(data)) {
            throw new ValidationError(validateUpdate520.errors);
        }
        return { status: res.status, data };
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function statistics({ fetcher, init, params, body, host, }) {
    if (!validateStatisticsBody(body)) {
        throw new ValidationError(validateStatisticsBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/statistics`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateStatistics200(data)) {
                throw new ValidationError(validateStatistics200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateStatistics403(data)) {
                throw new ValidationError(validateStatistics403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function requestAudioStream({ fetcher, init, params, body, host, }) {
    if (!validateRequestAudioStreamBody(body)) {
        throw new ValidationError(validateRequestAudioStreamBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/request_audio_stream`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateRequestAudioStream200(data)) {
                throw new ValidationError(validateRequestAudioStream200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateRequestAudioStream403(data)) {
                throw new ValidationError(validateRequestAudioStream403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function requestVideoStream({ fetcher, init, params, body, host, }) {
    if (!validateRequestVideoStreamBody(body)) {
        throw new ValidationError(validateRequestVideoStreamBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/request_video_stream`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateRequestVideoStream200(data)) {
                throw new ValidationError(validateRequestVideoStream200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateRequestVideoStream403(data)) {
                throw new ValidationError(validateRequestVideoStream403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function releaseAudioStream({ fetcher, init, params, body, host, }) {
    if (!validateReleaseAudioStreamBody(body)) {
        throw new ValidationError(validateReleaseAudioStreamBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/release_audio_stream`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateReleaseAudioStream200(data)) {
                throw new ValidationError(validateReleaseAudioStream200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateReleaseAudioStream403(data)) {
                throw new ValidationError(validateReleaseAudioStream403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
export async function releaseVideoStream({ fetcher, init, params, body, host, }) {
    if (!validateReleaseVideoStreamBody(body)) {
        throw new ValidationError(validateReleaseVideoStreamBody.errors);
    }
    const res = await fetcher(`${host}/api/client/v2/conferences/${encodeURIComponent(params.conferenceAlias)}${params.breakoutUuid ? `/breakouts/${encodeURIComponent(params.breakoutUuid)}` : ''}/participants/${encodeURIComponent(params.participantUuid)}/calls/${encodeURIComponent(params.callUuid)}/release_video_stream`, {
        ...init,
        method: 'post',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (res.status === 200) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateReleaseVideoStream200(data)) {
                throw new ValidationError(validateReleaseVideoStream200.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    if (res.status === 403) {
        if (res.headers.get('content-type')?.startsWith('application/json')) {
            const data = await res.json();
            if (!validateReleaseVideoStream403(data)) {
                throw new ValidationError(validateReleaseVideoStream403.errors);
            }
            return { status: res.status, data };
        }
        else {
            throw new NonJSONResponseError(res.headers.get('content-type'), await res.text());
        }
    }
    throw new Error(`Unexpected status ${res.status}`);
}
//# sourceMappingURL=index.js.map